import React, { useEffect, useState } from 'react'
import Svg from '../../../../../../component/common/Svg'
import ReportImg1 from '../../../../../../assets/images/report-1.png'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router'
import { useVerifySurveyId } from '../../../../../../hooks'
import { SET_CURRENT_REPORT } from '../../../../../../store/constant'
import DeleteWarning from '../../../../../../component/common/modals/DeleteWarning'
import { changeDefaultReport, deleteReport, duplicateReport } from '../../../../../../store/actions/reportAction'
import DuplicateWithName from '../../../../../../component/common/modals/DuplicateWithName'
import { useTranslation } from 'react-i18next';


const ReportCard = ({ report, language_code }) => {

    //=> States <==
    const [reportName, setReportName] = useState('')
    const [isVisibleDuplicate, setIsVisibleDuplicate] = useState(false)

    //custom hooks
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const survey_id = useVerifySurveyId()

    const { t, i18n } = useTranslation();

    //==> Functionalities <==
    const handleEditReport = ({ su_survey_report_id }) => {
        dispatch({ type: SET_CURRENT_REPORT, payload: su_survey_report_id })
        navigate(`/admin/survey/report/templates?survey_id=${survey_id}`)
    }

    const handleDeleteReport = ({ su_survey_report_id }) => {
        const payload = {
            report_id: su_survey_report_id
        }
        dispatch(deleteReport(payload))
    }

    const handleDuplicateReport = ({ su_survey_report_id }, name) => {
        const successCallback = () => {
            setIsVisibleDuplicate(false)
        }

        const payload = {
            report_id: su_survey_report_id,
            report_name: name,
            language_code
        }
        dispatch(duplicateReport(payload, successCallback))
    }

    const handleMakeDefault = (data) => {
        const payload = {
            report_id: data.su_survey_report_id,
            survey_id
        }
        dispatch(changeDefaultReport(payload, data))
    }

    //Effects
    useEffect(() => {
        let reportName = report.su_survey_report_name && JSON.parse(report.su_survey_report_name)[language_code]
        setReportName(reportName)
    }, [report])


    return (
        <>
            <div className="col-lg-3 col-md-6">
                <div to="" className="report-inner" >
                    <div className="report-img mb-1" onClick={() => handleEditReport(report)}>
                        {/* <img src={ReportImg1} className="img-fluid" alt='' /> */}
                        <h4>{reportName ?? ''}</h4>
                    </div>
                    <div className="d-flex align-items-start">
                        <div className="flex-grow-1 pe-2">
                            <div className="report-title mt-1" onClick={() => handleEditReport(report)}>{reportName ?? ''}</div>
                        </div>
                        <div className="dropdown table-dropdown">
                            <button className="btn dropdown-tgl" type="button" id="viewoptions" data-bs-toggle="dropdown"
                                aria-haspopup="true" aria-expanded="false">
                                <Svg name="action" />
                            </button>
                            <div className="dropdown-menu" aria-labelledby="viewoptions">

                                {window.modulePermissions.M13.edit == 1 && (<span className="dropdown-item d-flex align-items-center" onClick={() => { handleEditReport(report) }}>
                                    <div className="icon-circle me-3">
                                        <Svg name="Edit-Survey" />
                                    </div>
                                    <span>{t('survey.builder.edit')}</span>
                                </span>)}

                                {window.modulePermissions.M13.add == 1 && (<span className="dropdown-item d-flex align-items-center" onClick={() => setIsVisibleDuplicate(true)}>
                                    <div className="icon-circle me-3">
                                        <Svg name="duplicate" />
                                    </div>
                                    <span>{t('survey.report.duplicate')}</span>
                                </span>)}

                                {window.modulePermissions.M13.edit == 1 && (<span className="dropdown-item d-flex align-items-center" onClick={() => handleMakeDefault(report)}>
                                    <div className="icon-circle me-3">
                                        <Svg name="make-default" />
                                    </div>
                                    <span>{t('survey.report.make')}</span>
                                </span>)}
                                {window.modulePermissions.M13.del == 1 && (
                                <span className="dropdown-item d-flex align-items-center" data-bs-toggle="modal" data-bs-target={`#deleteReport_${report?.su_survey_report_id}`}>
                                    <div className="icon-circle me-3">
                                        <Svg name="delete" />
                                    </div>
                                    <span>{t('survey.report.delete')}</span>
                                </span>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <DeleteWarning
                id={`deleteReport_${report?.su_survey_report_id}`}
                title={'Are you sure?'}
                messageStr={`<p>${t('survey.customVariable.del1')} <strong>${reportName ?? ''}</strong> ${t('survey.customVariable.permanently')}</p>`}
                onSuccess={handleDeleteReport}
                data={report}
            />

            <DuplicateWithName
                open={isVisibleDuplicate}
                onSuccess={handleDuplicateReport}
                onCancel={() => setIsVisibleDuplicate(false)}
                data={report}
                title={'Duplicate report'}
                fieldName={'Report name'}
                fieldPlaceholder={'Report name'}
                fieldErrorMessage={'Report name is required'}
                defaultValue={`${reportName} (Copy)`}
                btnName={'Duplicate'}
            />

        </>
    )
}

export default ReportCard